import { useTranslation } from "react-i18next";
import { Button } from "@myphx-engineering/phx-design-system";
import { jsx } from "react/jsx-runtime";

//#region src/client/components/consent-action-buttons/ConsentActionButtons.tsx
const ConsentActionButtons = ({ isAttested, shouldAllowConsentAttestation, loading = false, onAccept, onRevoke }) => {
	const { t } = useTranslation("cons");
	return shouldAllowConsentAttestation ? /* @__PURE__ */ jsx(Button, {
		disabled: !isAttested,
		size: "lg",
		loading,
		onClick: onAccept,
		children: t("consent.actions.accept.button")
	}) : /* @__PURE__ */ jsx(Button, {
		color: "error",
		size: "lg",
		loading,
		onClick: onRevoke,
		children: t("consent.actions.revoke.button")
	});
};

//#endregion
export { ConsentActionButtons };